module.exports = __webpack_public_path__ + "static/media/cronos-network.4e156b70.png";